import { makeStyles } from "@material-ui/core/styles";
import { httpClient } from "api/httpClient";
import React, { useState } from "react";
import { Button, Confirm, useNotify, useRefresh } from "react-admin";
import { useNotifyError } from "utils/notifiers/useNotifyError";

const useBulkActionButtonStyles = makeStyles({
	label: {
		paddingLeft: "0",
	},
	button: {
		backgroundColor: "#f44336",
		color: "white",
		"&:hover": {
			backgroundColor: "#ff7961",
		},
	},
});

export const DeleteAllButton = ({
	resource,
	data,
	label = "osfc.buttons.delete",
	title = "osfc.buttons.confirm",
	content = "osfc.confirm.content",
	successMessage,
	disabled = false,
	onSuccess,
	onFailure,
	...props
}) => {
	const [open, setOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const notifyError = useNotifyError();
	const notify = useNotify();

	const bulkActionButtonClasses = useBulkActionButtonStyles();

	const handleClick = (e) => {
		e.stopPropagation();
		setOpen(true);
	};

	const handleDialogClose = () => setOpen(false);

	const handleConfirm = () => {
		setIsLoading(true);
		httpClient(resource, {
			method: "POST",
			body: JSON.stringify(data),
		})
			.then((response) => {
				notify(successMessage, "info");
				if (onSuccess) {
					onSuccess();
				}
			})
			.catch((error) => {
				notifyError(error);
			})
			.finally(() => {
				setIsLoading(false);
				setOpen(false);
			});
	};

	return (
		<>
			<Button
				label={label}
				classes={bulkActionButtonClasses}
				onClick={handleClick}
				disabled={disabled}
				{...props}
			/>
			<Confirm
				isOpen={open}
				loading={isLoading}
				title={title}
				content={content}
				onConfirm={handleConfirm}
				onClose={handleDialogClose}
				confirm="osfc.buttons.confirm"
			/>
		</>
	);
};
